import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { LeaseWizard } from '../../components/lease/LeaseWizard';
import { motion } from 'framer-motion';
export function LeaseGenerator() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-3826">
      <Sidebar data-id="element-3827" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-3828">
        <DashboardHeader data-id="element-3829" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-3830">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3831">
            <div className="mb-6 lg:mb-8" data-id="element-3832">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-3833">
                AI Lease Generator
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-3834">
                Create legally sound lease agreements in minutes.
              </p>
            </div>

            <LeaseWizard data-id="element-3835" />
          </motion.div>
        </div>
      </main>
    </div>;
}